import React from "react";
import { ROUTES } from "Navigation";
import { SubRoutesContainer } from "Features/Shared";

export const ViewMain: React.FC = () => {
  return <SubRoutesContainer route={ROUTES.VIEW} />;
};
